import React, { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import header_button_1 from "../assets/image/buttons/mdi_world.svg";
import header_button_2 from "../assets/image/buttons/mdi_question-mark-circle-outline.svg";
import unisat_icon from "../assets/image/unisat.svg";

const Buttons = () => {
  const [unisat, setUnisat] = useState(window.unisat);
  const [isWalletOpen, setIsWalletOpen] = useState(false);
  const [address, setAddress] = useState("");
  const [connected, setConnected] = useState(false);
  const selfRef = useRef({ accounts: [] });
  const { current: self } = selfRef;

  const closeWalletModal = () => {
    setIsWalletOpen(false);
  };

  const openWalletModal = () => {
    setIsWalletOpen(true);
  };

  const signIn = async () => {
    await unisat.requestAccounts();
    console.log("connecting ===>", await unisat.getPublicKey());
  };

  const connectWallet = async () => {
    try {
      const result = await unisat.requestAccounts();
      handleAccountsChanged(result);

      unisat.on("accountsChanged", (accounts) => {
        console.log(accounts.length);
        if (accounts.length > 0) {
          signIn();
        }
      });
    } catch (error) {
      console.log("Error occurred while connecting wallet:", error);
    }
  };

  const disconnectWallet = async () => {
    try {
      self.accounts = [];
      await unisat._pushEventHandlers.disconnect();

      if (self.accounts.length === 0) {
        setConnected(false);
        setAddress("");
      }
    } catch (error) {
      console.log("Error occurred while disconnecting wallet:", error);
    }
  };

  const handleAccountsChanged = (_accounts) => {
    if (self.accounts[0] === _accounts[0]) {
      // prevent from triggering twice
      return;
    }
    self.accounts = _accounts;
    if (_accounts.length > 0) {
      setConnected(true);

      setAddress(_accounts[0]);
    } else {
      setConnected(false);
    }
  };

  const handleClick = () => {
    closeWalletModal();
    connectWallet();
  };

  return (
    <div>
      <div className="px-4 py-5 xl:px-7 inline-flex truncate">
        {address ? (
          <div className="p-3 mx-3 text-sm text-white flex justify-center items-center bg-[#FF9601] rounded-lg overflow-hidden">
            {address}
          </div>
        ) : (
          <div />
        )}

        <a href="https://www.bitlend.org/" target="_blank">
          <div className="w-12 h-auto p-3 bg-[#FF9601] rounded-lg overflow-hidden hidden sm:inline-flex flex-col justify-start items-start gap-2.5">
            <button className="w-6 h-6 inline-flex justify-center items-center">
              <img src={header_button_1} />
            </button>
          </div>
        </a>
        <a href="https://ezfi.gitbook.io/bitlend/" target="_blank">
          <div className="w-12 h-auto p-3 ml-2.5 bg-[#FF9601] rounded-lg overflow-hidden hidden sm:inline-flex flex-col justify-start items-start gap-2.5">
            <button
              type="button"
              className="w-6 h-6 inline-flex justify-center items-center"
            >
              <img src={header_button_2} />
            </button>
          </div>
        </a>
        {connected ? (
          <div className="w-32 h-auto px-5 py-2 ml-2.5 bg-[#FF9601] rounded-lg overflow-hidden hidden sm:inline-flex flex-col justify-center items-center gap-2.5">
            <button
              className="text-[#FFF1DC] text-sm font-Outfit font-medium break-words"
              onClick={disconnectWallet}
            >
              Disconnect Wallet
            </button>
          </div>
        ) : (
          <div className="w-32 h-auto px-5 py-2 ml-2.5 bg-[#FF9601] rounded-lg overflow-hidden hidden sm:inline-flex flex-col justify-center items-center gap-2.5">
            <button
              className="text-[#FFF1DC] text-sm font-Outfit font-medium break-words"
              onClick={openWalletModal}
            >
              Connect Wallet
            </button>
          </div>
        )}

        {/* Wallet Modal */}
        <Transition appear show={isWalletOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeWalletModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-backdropBlurColor backdrop-blur-sm" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-1/5 transform overflow-hidden rounded-lg bg-tableBodyColor align-middle shadow-xl transition-all">
                    {/* Modal Title */}
                    <Dialog.Title
                      as="div"
                      className="w-full h-modalHeight flex justify-center items-center bg-tableColor p-7 text-bodyColor font-Inter text-2xl not-italic font-bold leading-normal"
                    >
                      Connect Wallet
                    </Dialog.Title>

                    {/* Modal Body */}
                    <div className="py-7 px-7 flex justify-center items-center">
                      <div
                        onClick={handleClick}
                        className="w-3/4 px-10 py-3 border border-opaBorderColor border-solid rounded-lg cursor-pointer"
                      >
                        <div className="flex justify-center items-center py-1 text-opaBodyColor text-center text-sm font-Inter font-medium break-words">
                          <img src={unisat_icon} className="w-1/2" />
                        </div>
                        <div className="text-bodyColor text-center text-lg font-Inter font-bold break-words">
                          UniSat
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    </div>
  );
};

export default Buttons;
